module.exports = __webpack_public_path__ + "static/img/p7-1.423880e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p7-1.jpg
// module id = 2BQd
// module chunks = 1